module.exports = __webpack_public_path__ + "media/images/icons/payment_second_step-948e87f394eff69f34ab38f8c986d911.svg";